import React from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:50586/api/';

const FrontPageTacos = ({ customConfig }) => {
    const logoSrc = customConfig?.coverLogo 
        ? `${API_URL.replace('/api/', '')}${customConfig.coverLogo}` 
        : "/img/page/xolos-five.png";
    const titleText = customConfig?.coverTitle || "Velocidad taquera";

    const introStyle = customConfig?.gameBackground 
        ? {
            backgroundImage: `url(${API_URL.replace('/api/', '')}${customConfig.gameBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          } 
        : {};

    return (
        <div className="taco-intro" style={introStyle}>
            {/* Contenedor de Logos y Título */}
            <div className="taco-intro__logo-container">
                <div className='d-flex align-items-center justify-content-center'>
                    {/* Logo central (ej. La Moderna, ADSL, o la marca patrocinadora) */}
                    <img src={logoSrc} className="taco-intro__logo" alt="Patrocinador Central" />
                </div>
                
                <p className="taco-intro__text text-uppercase fw-bold mt-4">Presentan</p>
                <p className="taco-intro__title text-uppercase fw-black text-center">{titleText}</p>
            </div>
        </div>
    );
};

export { FrontPageTacos };